import React, { useEffect, useRef, useState } from 'react';
import { isSet } from '../../../utils/commonUtils';
import FormInputs from '.';

const CheckboxDropDown = (props) => {
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [searchtext, setSearchtext] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const {
        options,
        changeHandler,
        value,
        isMulti,
    } = props;

    useEffect(() => {
        setSelectedOptions(options);
    }, [options]);

    useEffect(() => {
        if (value !== "" && value !== null && isSet(value, []).length > 0) {
            const isselectAll = options.every(item => isSet(value, []).includes(item.value.toString()));
            
            if (isselectAll && options.length>0){ setSelectAll(true);}
        }
    }, [value]);

    // Handle outside click to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onchangeHanlder = (opt, e) => {
        setSelectAll(false);
        changeHandler(opt, isMulti, e);
    };

    const selectAllHanlder = () => {        
        setSelectAll(prev => !prev);
        let filter = selectAll
            ? selectedOptions.filter(item => isSet(value, []).includes(item.value.toString()))
            : selectedOptions.filter(item => !isSet(value, []).includes(item.value.toString()));
        isSet(filter, []).forEach((val) => {
            changeHandler(val, isMulti, selectAll?false:true);
        });
    };

    const searchHanlder = (val) => {
        setSearchtext(val);
        const searchTerm = val.toLowerCase();
        const opt = options.filter(val => val.label.toLowerCase().includes(searchTerm));
        setSelectedOptions(opt);
        setSelectAll(false);
    };
    const renderMultiSelectLabel = () => {
        const selected =options ? options.filter(opt =>
            isSet(value, []).includes(opt.value.toString())
        ):[];
        const count = selected.length;

        if (count === 0) return "0 Selected";
        if (count <= 3) return `${selected.map(opt => opt.label).join(', ')}`;
        if (selectAll) return `All Selected(${count})`;
        return `${selected.slice(0, 3).map(opt => opt.label).join(', ')}...(${count})`;
    }    

    return (
        <div className="d-flex" ref={dropdownRef}>
            <div className="form-group w-100 mx-1 mb-0 position-relative">
                <div
                    type="button"
                    className="btn btn-outline-secondary w-100 my-1 text-truncate dropdown-toggle"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    {isMulti === 1
                        ? renderMultiSelectLabel()
                        :renderMultiSelectLabel()}
                </div>

                {isOpen && (
                    <div className="dropdown-menu w-100 show sh_emrdropdownmenubox shadow py-0">
                        <div className="sh_cardBox mb-0 position-relative">
                            <div className="sh_cardHeader border-bottom" style={{ position: "sticky", top: 0 }}>
                                <div className="d-flex pr-1 align-items-center position-relative">
                                    {(isMulti === 1 ||isMulti===true) && (
                                        <div className="form-check">
                                            <FormInputs
                                                type="Checkbox"
                                                className="form-check-input cursor-pointer"
                                                id="checkbox-1"
                                                value={selectAll}
                                                changeHandler={() => selectAllHanlder()}
                                            />
                                        </div>
                                    )}
                                    <div className='w-100 '>
                                        <FormInputs
                                            type="TextInput"
                                            placeholder="search"
                                            className="form-control"
                                            value={searchtext}
                                            changeHandler={(val) => searchHanlder(val)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="sh_cardBody sh_emrdropdownmenu p-0">
                                {selectedOptions.length > 0 ? (
                                    isMulti === true || isMulti === 1 ? (
                                        selectedOptions.map((opt, ind) => (
                                            <div key={ind}>
                                                <div className="dropdown-item d-flex align-items-center">
                                                    <div>
                                                        <FormInputs
                                                            type="Checkbox"
                                                            id={`${opt.value}_${ind}`}
                                                            className="cursor-pointer"
                                                            value={isSet(props.value, []).includes(opt.value)}
                                                            changeHandler={(e) => onchangeHanlder(opt, e)}
                                                        />
                                                    </div>
                                                    <label className="pl-2 mb-0" htmlFor={`${opt.value}_${ind}`}>{opt.label}</label>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        selectedOptions.map((opt, ind) => (
                                            <div key={ind}>
                                                <div className="dropdown-item d-flex align-items-center">
                                                    <div>
                                                        <FormInputs
                                                            type="Radio"
                                                            name={opt.value}
                                                            id={`${opt.value}_${ind}`}
                                                            className="cursor-pointer"
                                                            value={isSet(props.value, "").toString() === opt.value.toString()}
                                                            changeHandler={(e) => onchangeHanlder(opt, e)}
                                                        />
                                                    </div>
                                                    <label className="pl-2 mb-0" htmlFor={`${opt.value}_${ind}`} >{opt.label}</label>
                                                </div>
                                            </div>
                                        ))
                                    )
                                ) : (
                                    <div className="dropdown-item d-flex align-items-center">
                                        <label className="pl-2 mb-0">No records found</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

CheckboxDropDown.defaultProps = {
    value: "",
    isMulti: 0,
    className: 'form-check',
    checked: false,
    name: 'default',
    style: {},
    id: 'default',
    label: '',
    readOnly: false,
    options:[],
    disabled: false,
    changeHandler: () => { }
};

export default CheckboxDropDown;
